import styles from "@/styles/flashcard.module.css";
import { FlexColumn } from "@/components/Flex";
import { clsx } from "clsx";

type FlashcardMockProps = {
    onClick: () => void;
    style?: React.CSSProperties;
    className?: string;
    children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const FlashcardMock = ({ children, onClick, style, className, ...divProps }: FlashcardMockProps) => {
    return (
        <FlexColumn
            className={clsx(styles.flashcard, className)}
            onClick={onClick}
            style={{ height: "57rem", padding: "2.8rem 3rem", boxSizing: "border-box", ...style }}
            {...divProps}>
            {children}
        </FlexColumn>
    );
};

export default FlashcardMock;
